import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  donations: [],
  persons: []
}
const ActionsPartners = generateActions('externalpartners/externalpartner/GET_ACTIONS')

export const clear = createAction('externalpartners/externalpartner/CLEAR')


export const getActions1 = createAction(API_CONST, externalpartnerId => ({
  actions: ActionsPartners,
  url: `externalpartners/${externalpartnerId}/actions`
}))

const reformatActions = (items = []) => items.map(item => {

  return {
    _id: item._id,
    title: item.title,//название
    image: item.image,
    sum: item.externalPaymentsStats.sum,
	personsCount: item.externalPaymentsStats.personsCount
  }
})

export default handleActions({
  [clear]: state => ({ ...initial }),

  [ActionsPartners[1]]: (state, { payload = [] }) => ({
    ...state,
    actions: payload
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/externalpartners/externalpartner.js